import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { OAuthModule } from 'angular-oauth2-oidc';
import * as $ from 'jquery';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { translateModuleConfigurator } from './translate-module.configurator';
import { CustomerModule } from './water-loss/features/customer/customer.module';
import { WaterLossModule } from './water-loss/water-loss.module';

// Golden Layoyt requires to have JQuery as global in the window object.
window['$'] = $;

// Translation json configuration moved to translate-module.configurator.ts
@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent],
    exports: [CustomerModule, TranslateModule], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        OAuthModule.forRoot(),
        StoreModule.forRoot({}),
        EffectsModule.forRoot(),
        TranslateModule.forRoot(translateModuleConfigurator),
        //AppHubModule,
        WaterLossModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {
  static injector: Injector;

  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
